import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import styles from "./styles.module.scss";
import Input from "../../../custom/input/input";
import DownloadFile from "../../../custom/downloadFile/downloadFile";
import { useAtomValue } from "jotai";
import { userData } from "../../../state";
import { useQuery } from "@tanstack/react-query";
import { getProfessionalBody } from "../../../requests";
import { Spin } from "antd";
import { AxiosError } from "axios";
import { format } from "date-fns";
import AddProfessionalBodyModal from "./addProfessionalBodyModal";
import { useState } from "react";
import Button from "../../../custom/button/button";
import classNames from "classnames";

const ProfessionalBody = () => {
  const user = useAtomValue(userData);
  const [open, setOpen] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["professional-body"],
    queryFn: () => getProfessionalBody(user?.MemberId!),
  });

  const professionalBodyData = data?.Data as ProfessionalBody[];

  const formik = useFormik<FormikValues>({
    initialValues: {
      professionalBody: "",
      membershipGrade: "",
      electionDate: "",
    },
    onSubmit: () => {},
    enableReinitialize: true,
  });

  if (isLoading) return <Spin />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  const professionalDocument = professionalBodyData?.map(
    (professionalBodyData, index) => (
      <section className={styles.details} key={professionalBodyData.Id}>
        <h2>PROFESSIONAL BODY - {index + 1}</h2>
        <hr className={styles.hr} />
        <section className={styles.field}>
          <Field
            as={Input}
            type="text"
            name="professionalBody"
            label="Professional Body"
            placeholder={professionalBodyData?.BodyName}
            className={styles.input}
          />
        </section>
        <section className={styles.field}>
          <Field
            as={Input}
            type="text"
            name="membershipGrade"
            label="Membership Grade (Optional)"
            placeholder={professionalBodyData?.MembershipGrade}
            className={styles.input}
          />
        </section>
        <section className={styles.field}>
          <Field
            as={Input}
            type="text"
            name="electionDate"
            label="Election Date (Optional)"
            placeholder={
              professionalBodyData?.ElectionDate
                ? format(
                    new Date(professionalBodyData?.ElectionDate ?? null),
                    "yyyy-MM-dd"
                  )
                : null
            }
            className={styles.input}
          />
        </section>
        <section className={styles.field}>
          <DownloadFile
            className={styles.input}
            title="Upload Certificate"
            documentName={professionalBodyData?.BodyName}
            documentSize={10023}
            documentUrl={professionalBodyData?.FileUrl}
          />
        </section>
      </section>
    )
  );

  return (
    <div>
      <FormikProvider value={formik}>
        <Button
          className={classNames(styles.lightBtn, styles.end)}
          onClick={() => setOpen(true)}
          text="Add Professional Body"
        />
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          {professionalDocument}
        </form>
      </FormikProvider>
      <AddProfessionalBodyModal
        open={open}
        handleClose={() => setOpen(false)}
      />
    </div>
  );
};

export default ProfessionalBody;
